import { gql } from 'apollo-boost';

const createUserMutation = gql`
  mutation createUserMutation($user: UserCreateInput!) {
    user {
      create(user: $user) {
        rowVersion
        firstName
        middleName
        lastName
        loginEmail
        recoveryEmail
        phone
        timeZoneId
        cultureId
        id
      }
    }
  }
`;

const updateUserMutation = gql`
  mutation updateUser($user: UserUpdateInput!) {
    user {
      update(user: $user) {
        rowVersion
        firstName
        middleName
        lastName
        loginEmail
        phone
        timeZoneId
        cultureId
        id
        preferences {
          emailDigestReceiveAll
          emailDigestReceiveTime
          receiveEmailDigest
          notificationPreferences {
            includeInEmailDigest
            notificationReasonId
            receiveEmailNotifications
            receiveInAppNotifications
          }
        }
      }
    }
  }
`;

const deleteUserMutation = gql`
  mutation DeleteUser($userId: Int!) {
    user {
      delete(userId: $userId)
    }
  }
`;

const changeUserEmailMutation = gql`
  mutation ChangeLoginEmail($loginEmailChange: UserLoginEmailChangeInput!) {
    user {
      changeLoginEmail(loginEmailChange: $loginEmailChange) {
        rowVersion
        firstName
        middleName
        lastName
        loginEmail
        phone
        timeZoneId
        cultureId
        id
        preferences {
          emailDigestReceiveAll
          emailDigestReceiveTime
          receiveEmailDigest
          notificationPreferences {
            includeInEmailDigest
            notificationReasonId
            receiveEmailNotifications
            receiveInAppNotifications
          }
        }
      }
    }
  }
`;

const resetUserPassword = gql`
  mutation ResetUserPasswordInput($userInfo: ResetUserPasswordInput!) {
    user {
      resetPassword(userInfo: $userInfo) {
        rowVersion
        id
      }
    }
  }
`;

export {
  createUserMutation,
  updateUserMutation,
  deleteUserMutation,
  changeUserEmailMutation,
  resetUserPassword
};
